import { authConfig } from '@consigli/hooks';
import { logout } from '@consigli/oauth';
import { getSolutionViewerUrl } from '@consigli/utils';
import { FC } from 'react';
import {
  HiOutlineCog,
  HiOutlineDocumentText,
  HiOutlineExternalLink,
  HiOutlineFolder,
  HiOutlineOfficeBuilding,
  HiOutlineSparkles,
  HiOutlineUser,
} from 'react-icons/hi';
import { RxDashboard } from 'react-icons/rx';

import { ActionButton } from '@/components';
import { BackofficeRoutes } from '@/route-names';

import { NavigationTab } from './navigation-tab';

const logoUrl = '/aecom-logo-black.svg';

export const Navbar: FC = () => {
  const solutionViewerLink = getSolutionViewerUrl();

  return (
    <>
      <nav className="bg-white w-full fixed top-0 left-0 z-50 py-4 px-8 flex items-center justify-between">
        <img src={logoUrl} alt="logo" className="h-12 w-auto" />
        <div className="flex items-center gap-4">
          <NavigationTab icon={RxDashboard} to={'/'} label="Dashboard" />
          <NavigationTab
            icon={HiOutlineFolder}
            to={`/${BackofficeRoutes.PROJECTS}`}
            label="Projects"
          />
          <NavigationTab
            icon={HiOutlineOfficeBuilding}
            to={`/${BackofficeRoutes.ORGANIZATIONS}`}
            label="Organizations"
          />
          <NavigationTab icon={HiOutlineUser} to={`/${BackofficeRoutes.USERS}`} label="Users" />
          <NavigationTab
            icon={HiOutlineDocumentText}
            to={`/${BackofficeRoutes.REPORT_TEMPLATES}`}
            label="Templates"
          />
          <NavigationTab
            icon={HiOutlineSparkles}
            to={`/${BackofficeRoutes.BEAMSTAR}`}
            label="Beamstar"
          />
          <NavigationTab
            icon={HiOutlineExternalLink}
            to={solutionViewerLink}
            label="Solution Viewer"
          />
          <ActionButton
            icon={<HiOutlineCog size={20} />}
            actions={[
              {
                label: 'Logout',
                onClick: () => {
                  logout(authConfig);
                },
                disabled: false,
                destructive: false,
              },
            ]}
          />
        </div>
      </nav>
    </>
  );
};
